import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Organization } from 'src/models/organization';
import { Secretary } from 'src/models/secretary';
import {
  Account,
  SearchAccountsRequest,
  SearchAccountsResponse,
  SearchDocumentsRequest,
  SearchDocumentsResponse
} from 'src/models/account.model';
import { Horse } from 'src/models/horse';
import { SearchEventsGroupsRequest, SearchEventsGroupsResponse } from 'src/models/rodeoEventGroup';
import { SearchAccountGroupsRequest, SearchAccountsGroupsResponse } from 'src/models/account-group';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  constructor(private api: ApiService) {}

  async getOrganizationsByAccount() {
    return await this.api.get<Organization[]>(
      `${this.api.endpoints.search}/OrganizationsByAccount`,
    );
  }

  async getSecretariesByAccount() {
    return await this.api.get<Secretary[]>(
      `${this.api.endpoints.search}/Secretaries`,
    );
  }

  async searchAccounts(query: string) {
    return this.api.get<Account[]>(
      `${this.api.endpoints.search}/AccountsByName?query=${query}`,
    );
  }

  async searchAccountsPaginated(filters: SearchAccountsRequest) {
    return this.api.post<SearchAccountsResponse>(
      `${this.api.endpoints.search}/SearchAccountsForStaff`,
      filters,
    );
  }

  async searchHorses(query: string, siresOnly = false, damsOnly = false) {
    return this.api.get<Horse[]>(
      `${this.api.endpoints.search}/Horses?name=${query}&siresOnly=${siresOnly}&damsOnly=${damsOnly}`,
    );
  }

  async searchAccountsDocuments(filters: SearchDocumentsRequest) {
    return this.api.post<SearchDocumentsResponse>(
      `${this.api.endpoints.search}/searchAccountsDocuments`,
        filters
    );
  }

  async searchEventsGroups(filters: SearchEventsGroupsRequest) {
    return this.api.post<SearchEventsGroupsResponse>(
      `${this.api.endpoints.search}/searchEventsGroups`,
      filters,
    );
  }

  async searchAccountsGroups(filters: SearchAccountGroupsRequest) {
    return this.api.post<SearchAccountsGroupsResponse>(
      `${this.api.endpoints.search}/searchAccountsGroups`,
      filters,
    );
  }
}
